module.exports = __webpack_public_path__ + "img/double.e6211691.svg";